<div class="ecb-x-corporate-booking-wrapper">


  <!-- =================================================== -->
  <!-- TITLE -->
  <!-- =================================================== -->

  <div class="ecb-x-corporate-booking-title">

    <h2>
      Booking Details
    </h2>

  </div>

  <!-- ===================================================== -->
  <!-- CORPORATE CLIENT DETAILS -->
  <!-- ===================================================== -->

  <div class="ecb-x-corporate-client-details" *ngIf="isBookNowSubmitted">

    <div class="ecb-x-corporate-client-details-title">

      <h2>
        Client Details
      </h2>

    </div>


    <div class="ecb-x-corporate-client-details-form">

      <div class="row g-4">


        <!-- ================================================= -->
        <!-- COMPANY NAME -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="companyName">

            Company Name
            <span>*</span>

          </label>


          <input id="companyName" type="text" [maxlength]="100" class="form-control" [(ngModel)]="companyName"
            name="companyName" placeholder="Enter company name">

        </div>

        <!-- ================================================= -->
        <!-- COMPANY Email -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="companyEmail">

            Company Email
            <span>*</span>

          </label>


          <input id="companyEmail" type="email" class="form-control" [maxlength]="100" [(ngModel)]="companyEmail"
            name="companyEmail" placeholder="Enter company email" #companyEmailCtrl="ngModel" appEmailValidator>
        </div>


        <!-- ================================================= -->
        <!-- REQUESTED BY PHONE -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="requestedByPhone">

            Contact Number
            <span>*</span>

          </label>


          <input id="requestedByPhone" type="tel" class="form-control" [(ngModel)]="requestedByPhone"
            name="requestedByPhone" placeholder="Enter contact number" appPhoneNumberValidation>

        </div>


        <!-- ================================================= -->
        <!-- SITE LOCATION -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="siteLocationAddress">

            Site Location / Address


          </label>

          <select id="siteLocationAddress" class="form-select ecb-site-location-select"
            [(ngModel)]="siteLocationSelection" name="siteLocationSelection" [disabled]="isLoadingSiteLocations"
            (ngModelChange)="onSiteLocationSelectionChange()">

            <option [ngValue]="''">
              {{
              isLoadingSiteLocations
              ? 'Loading site locations...'
              : 'Select site location'
              }}
            </option>

            <option *ngFor="let location of siteLocations" [ngValue]="location.locationName">

              {{ location.locationName }}

            </option>

            <option [ngValue]="'OTHER'">
              Client Site/Location (Other)
            </option>

          </select>

          <input *ngIf="siteLocationSelection === 'OTHER'" type="text"
            class="form-control ecb-site-location-other-input mt-2" [(ngModel)]="siteLocationAddress"
            name="siteLocationAddressOther" maxlength="250" placeholder="Enter site location / address">
          <!-- <input id="siteLocationAddress" type="text" class="form-control" [(ngModel)]="siteLocationAddress"
                name="siteLocationAddress" placeholder="Enter site location or address">
 -->
        </div>


        <!-- ================================================= -->
        <!-- REQUESTED BY -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="requestedBy">

            Requested By


          </label>


          <input id="requestedBy" type="text" class="form-control" [maxlength]="100" [(ngModel)]="requestedBy"
            name="requestedBy" placeholder="Enter requested by">

        </div>




        <!-- ================================================= -->
        <!-- ON SITE SUPERVISOR -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="onSiteSupervisor">

            On Site Supervisor

          </label>


          <input id="onSiteSupervisor" type="text" class="form-control" [maxlength]="100" [(ngModel)]="onSiteSupervisor"
            name="onSiteSupervisor" placeholder="Enter on site supervisor">

        </div>


        <!-- ================================================= -->
        <!-- SUPERVISOR PHONE -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <label for="onSiteSupervisorPhone">

            Supervisor Phone Number

          </label>


          <input id="onSiteSupervisorPhone" type="tel" class="form-control" [(ngModel)]="onSiteSupervisorPhone"
            name="onSiteSupervisorPhone" appPhoneNumberValidation placeholder="Enter supervisor phone number">

        </div>


        <!-- ================================================= -->
        <!-- DATE REQUESTED -->
        <!-- ================================================= -->

        <div class="col-12 col-md-2">

          <label for="dateRequested">

            Date Requested


          </label>


          <input id="dateRequested" type="date" class="form-control" [(ngModel)]="dateRequested" name="dateRequested">

        </div>


        <!-- ================================================= -->
        <!-- TRAINING DATE -->
        <!-- ================================================= -->

        <div class="col-12 col-md-2">

          <label for="dateTrainingRequired">

            Date Training Required


          </label>


          <!-- Date is automatically calculated from all participant calendar selections. -->
          <input id="dateTrainingRequired" type="date" class="form-control" [(ngModel)]="dateTrainingRequired"
            [min]="todayDate" name="dateTrainingRequired"
            title="Automatically set to the earliest participant training date">

        </div>


        <!-- ================================================= -->
        <!-- AWARDS -->
        <!-- ================================================= -->

        <!--   <div class="col-12 col-lg-3">

          <label>

            Do You Require a Copy of the Awards Issued?

          </label>


          <div class="ecb-x-corporate-choice-group">

            <label>

              <input type="radio" name="copyOfAwardsRequired" value="YES" [(ngModel)]="copyOfAwardsRequired">

              Yes

            </label>


            <label>

              <input type="radio" name="copyOfAwardsRequired" value="NO" [(ngModel)]="copyOfAwardsRequired">

              No

            </label>

          </div>

        </div>
 -->

        <!-- ================================================= -->
        <!-- METRO CLIENT -->
        <!-- ================================================= -->

        <!--     <div class="col-12 col-lg-1">

          <label>

            Metro Client?

          </label>


          <div class="ecb-x-corporate-choice-group">

            <label>

              <input type="radio" name="isMetroClient" value="YES" [(ngModel)]="isMetroClient">

              Yes

            </label>


            <label>

              <input type="radio" name="isMetroClient" value="NO" [(ngModel)]="isMetroClient">

              No

            </label>

          </div>

        </div> -->


        <!-- ================================================= -->
        <!-- PEGASUS -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4" *ngIf="isMetroClient === 'YES'">

          <label>

            Upload Award Evidence to Pegasus?

          </label>


          <div class="ecb-x-corporate-choice-group">

            <label>

              <input type="radio" name="uploadAwardEvidenceToPegasus" value="YES"
                [(ngModel)]="uploadAwardEvidenceToPegasus">

              Yes

            </label>


            <label>

              <input type="radio" name="uploadAwardEvidenceToPegasus" value="NO"
                [(ngModel)]="uploadAwardEvidenceToPegasus">

              No

            </label>

          </div>

        </div>

      </div>

    </div>
    <div class="alert alert-danger mx-4 mt-3" *ngIf="companyEmailCtrl.invalid &&
         (companyEmailCtrl.dirty || companyEmailCtrl.touched)">

      <span *ngIf="companyEmailCtrl.errors?.['invalidEmail']">
        Please enter a valid email address.
      </span>

    </div>
  </div>



  <div *ngIf="!isBookNowSubmitted">
    <!-- =================================================== -->
    <!-- SETTINGS -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-settings" *ngIf="!isBookNowSubmitted">
      <div class="row g-4 align-items-end">
        <!-- Participants -->
        <div class="col-12 col-md-6 col-xl-3">
          <label>
            Number of Participants
          </label>
          <input type="number" min="1" max="100" class="form-control" [(ngModel)]="numberOfParticipants"
            name="numberOfParticipants" (change)="updateParticipantCount()">
        </div>

        <!-- Number UOC -->
        <div class="col-12 col-md-6 col-xl-3">
          <label> Number of UOC</label>
          <input type="number" min="1" max="5" class="form-control" [(ngModel)]="numberOfUOC" name="numberOfUOC"
            (change)="updateUOCCount()">
        </div>
        <!-- Number VOC -->
        <div class="col-12 col-md-6 col-xl-3">
          <label>
            Number of VOC
          </label>
          <input type="number" min="1" max="10" class="form-control" [(ngModel)]="numberOfVOC" name="numberOfVOC"
            (change)="updateVOCCount()">
        </div>

        <!-- Reset -->
        <div class="col-12 col-xl-3">
          <button type="button" class="btn ecb-x-corporate-reset-button" (click)="resetCorporateForm()">
            <i class="bi bi-arrow-clockwise"></i>
            Reset
          </button>
        </div>
      </div>
    </div>



    <!-- =================================================== -->
    <!-- PARTICIPANT TABLE -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-table-wrapper" *ngIf="!isBookNowSubmitted">

      <table class="ecb-x-corporate-table">


        <!-- ================================================= -->
        <!-- TABLE HEADER -->
        <!-- ================================================= -->

        <thead>


          <!-- HEADER ROW 1 -->
          <tr>


            <!-- Number -->
            <th rowspan="3" class="ecb-x-corporate-number-column">
            </th>


            <!-- Participant Name -->
            <th rowspan="3" class="ecb-x-participant-name-heading">

              PARTICIPANT FULL NAME

              <span>
                *
              </span>


              <small>
                Enter participant name
              </small>

            </th>


            <!-- Training Required -->
            <th [attr.colspan]="
                  numberOfUOC +
                  numberOfVOC
                " class="ecb-x-training-required-heading">

              TRAINING REQUIRED

            </th>


            <!-- Calendar Selection -->
            <th rowspan="3" class="ecb-x-calendar-action-heading">
              CALENDAR
            </th>

            <!-- Remove -->
            <th rowspan="3">
            </th>

          </tr>



          <!-- HEADER ROW 2 -->
          <tr>


            <!-- UOC Group -->
            <th [attr.colspan]="numberOfUOC" class="ecb-x-corporate-uoc-main-heading">

              UNIT OF COMPETENCY (UOC)

            </th>


            <!-- VOC Group -->
            <th [attr.colspan]="numberOfVOC" class="ecb-x-corporate-voc-main-heading">

              VERIFICATION OF COMPETENCY (VOC)

            </th>

          </tr>



          <!-- HEADER ROW 3 -->
          <tr>


            <!-- UOC 1 - 4 -->
            <th *ngFor="
                  let column
                  of uocColumns
                " class="ecb-x-corporate-uoc-heading">

              UOC {{ column }}

            </th>


            <!-- VOC 1 - 4 -->
            <th *ngFor="
                  let column
                  of vocColumns
                " class="ecb-x-corporate-voc-heading">

              VOC {{ column }}

            </th>

          </tr>

        </thead>



        <!-- ================================================= -->
        <!-- PARTICIPANT BODY -->
        <!-- ================================================= -->

        <tbody>

          <tr *ngFor="
                let participant
                of participants;

                let participantIndex =
                index
              ">


            <!-- Number -->
            <td class="ecb-x-corporate-number-column">

              {{ participantIndex + 1 }}

            </td>


            <!-- Participant Name -->
            <td class="ecb-x-participant-name-cell">

              <input type="text" class="form-control" maxlength="50" [(ngModel)]="
                    participant.fullName
                  " [name]="
                    'participantName_' +
                    participantIndex
                  " placeholder="Click or tab here to participant">

            </td>



            <!-- =========================================== -->
            <!-- UOC COLUMNS -->
            <!-- =========================================== -->

            <td class="ecb-x-uoc-select-cell" *ngFor="
                  let column
                  of uocColumns;

                  let uocIndex =
                  index
                ">


              <select class="form-select custom-select" [(ngModel)]="participant.uocIds[uocIndex]"
                [name]="'participantUOC_' + participantIndex + '_' + uocIndex">


                <option [ngValue]="null">

                  Select UOC
                  {{ column }}

                </option>


                <option *ngFor="let course of allUOCCourses" [ngValue]="course.id" [hidden]="
    isUOCSelected(
      participant,
      course.id,
      uocIndex
    )
  ">


                  {{ course.courseTitle }}

                </option>

              </select>

            </td>



            <!-- =========================================== -->
            <!-- VOC COLUMNS -->
            <!-- =========================================== -->

            <td class="ecb-x-voc-select-cell" *ngFor="
                  let column
                  of vocColumns;

                  let vocIndex =
                  index
                ">


              <select class="form-select" [(ngModel)]="
                    participant
                      .vocIds[
                        vocIndex
                      ]
                  " [name]="
                    'participantVOC_' +
                    participantIndex +
                    '_' +
                    vocIndex
                  ">


                <option [ngValue]="null">

                  Select VOC
                  {{ column }}

                </option>


                <option *ngFor="let voc of allVOCCourses" [ngValue]="voc.id"
                  [hidden]="  isVOCSelected( participant, voc.id, vocIndex ) ">

                  {{ voc.vocCode }}
                  -
                  {{ voc.vocName }}

                </option>

              </select>

            </td>




            <!-- =========================================== -->
            <!-- PARTICIPANT CALENDAR -->
            <!-- =========================================== -->

            <td class="ecb-x-participant-calendar-cell">

              <!-- Open the calendar for this exact participant row. -->
              <button type="button" class="btn ecb-x-corporate-calendar-button"
                [class.has-selection]="participant.calendarDate" title="Select course from calendar"
                (click)="openParticipantCalendar(participantIndex)">

                <i class="bi bi-calendar3"></i>

                <span>
                  {{ getParticipantCalendarDate(participant) }}
                </span>

              </button>

            </td>


            <td class="ecb-x-participant-remove-cell">

              <div class="d-flex align-items-center gap-2">


                <!-- Remove Participant -->
                <button type="button" class="btn ecb-x-corporate-remove-button" [disabled]="participants.length <= 1"
                  (click)="removeParticipant(participantIndex)">

                  <i class="bi bi-trash"></i>

                </button>

              </div>

            </td>

          </tr>

        </tbody>

      </table>

    </div>



    <!-- =================================================== -->
    <!-- ADD PARTICIPANT -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-add-row" *ngIf="!isBookNowSubmitted">

      <button type="button" class="btn ecb-x-corporate-add-button" (click)="addParticipant()">

        <i class="bi bi-person-plus"></i>

        Add Participant

      </button>

    </div>



    <!-- =================================================== -->
    <!-- OTHER ITEMS -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-other-title">

      LIST OTHERS NOT COVERED IN DROPDOWN BOXES ABOVE
      (WHERE REQUIRED)



    </div>



    <!-- =================================================== -->
    <!-- OTHER ROWS -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-other-row" *ngFor=" let row  of otherRows;   let rowIndex =   index    ">


      <!-- Row Number -->
      <div class="ecb-x-corporate-other-number">

        {{ rowIndex + 1 }}

      </div>



      <!-- ================================================= -->
      <!-- OTHER 1 - OTHER 5 -->
      <!-- ================================================= -->

      <div class="ecb-x-corporate-other-input" *ngFor="
            let column
            of otherColumns;

            let valueIndex =
            index;

            trackBy:
            trackByIndex
          ">


        <input type="text" class="form-control" maxlength="50" [(ngModel)]="
              row.values[
                valueIndex
              ]
            " [name]="
              'other_' +
              rowIndex +
              '_' +
              valueIndex
            " [placeholder]="
              'Click or tab here to enter ' +
              column 
            ">

      </div>



      <!-- Remove Other Row -->
      <div class="ecb-x-corporate-other-remove">

        <button type="button" class="btn ecb-x-corporate-remove-button" (click)="
              removeOtherRow(
                rowIndex
              )
            ">

          <i class="bi bi-trash"></i>

          Remove

        </button>

      </div>

    </div>



    <!-- =================================================== -->
    <!-- ADD OTHER ROW -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-add-row">

      <button type="button" class="btn ecb-x-corporate-add-button" (click)="addOtherRow()">

        <i class="bi bi-plus-lg"></i>

        Add Other Row

      </button>

    </div>



    <!-- =================================================== -->
    <!-- COMMENTS -->
    <!-- =================================================== -->

    <div class="ecb-x-corporate-comments">

      <label>

        ADDITIONAL INFORMATION / COMMENTS


      </label>


      <textarea class="form-control" rows="3" [(ngModel)]="
            additionalComments
          " name="additionalComments" placeholder="Enter any additional information or comments here...">
        </textarea>

    </div>

  </div>

  <!-- =================================================== -->
  <!-- ERROR -->
  <!-- =================================================== -->

  <div class="alert alert-danger mx-4 mt-3" *ngIf="
          corporateErrorMessage
        ">

    {{ corporateErrorMessage }}

  </div>



  <!-- =================================================== -->
  <!-- SUCCESS -->
  <!-- =================================================== -->

  <div class="alert alert-success mx-4 mt-3" *ngIf="
          corporateSuccessMessage
        ">

    {{ corporateSuccessMessage }}

  </div>



  <!-- =================================================== -->
  <!-- FOOTER -->
  <!-- =================================================== -->

  <div class="ecb-x-corporate-footer">


    <!-- Clear -->
    <button type="button" class="btn ecb-x-corporate-clear-button" (click)="resetCorporateForm()">

      <i class="bi bi-arrow-clockwise"></i>

      Clear All

    </button>

    <!-- back -->
    <button type="button" class="btn ecb-x-corporate-clear-button" *ngIf="isBookNowSubmitted" (click)="backForm()">

      <i class="bi bi-arrow-left"></i>

      Back

    </button>
    <!-- Save -->
    <button type="button" class="btn ecb-x-corporate-save-button" *ngIf="!isBookNowSubmitted" [disabled]="
            isSavingCorporateBooking
          " (click)="saveCorporateBooking()">


      <i class="bi bi-floppy" *ngIf="
              !isSavingCorporateBooking
            ">
      </i>


      <span *ngIf="
              !isSavingCorporateBooking
            ">

        Continue

      </span>


      <span *ngIf="
              isSavingCorporateBooking
            ">

        Saving...

      </span>

    </button>


    <button type="button" class="btn ecb-x-corporate-save-button" *ngIf="isBookNowSubmitted" [disabled]="
            isSavingCorporateBooking
          " (click)="sendEnquire()">


      <i class="bi bi-send" *ngIf="
              !isSavingCorporateBooking
            ">
      </i>


      <span *ngIf="
              !isSavingCorporateBooking
            ">

        Send Enquire/Booking

      </span>


      <span *ngIf="
              isSavingCorporateBooking
            ">

        Sending...

      </span>

    </button>
  </div>

</div>

 
<!--Start PARTICIPANT CALENDAR MODAL --> 
<div class="ecb-x-participant-calendar-backdrop" *ngIf="showParticipantCalendarModal"
  (click)="closeParticipantCalendar()">
  <div class="ecb-x-participant-calendar-modal ecb-x-public-calendar-look" (click)="$event.stopPropagation()">
    <div class="ecb-x-public-calendar-header">
      <div class="ecb-x-public-calendar-page-title">
        <div class="ecb-x-public-calendar-title-icon"><i class="bi bi-calendar3"></i></div>
        <div>
          <h2>Course Calendar</h2>
          <p>Select training for participant {{ participantCalendarIndex !== null ? participantCalendarIndex + 1 : '' }}
          </p>
        </div>
      </div>

      <div class="ecb-x-public-calendar-toolbar">
        <button type="button" class="btn ecb-x-public-calendar-today-button"
          (click)="goParticipantCalendarToday(participantCalendar)">Today</button>
        <button type="button" class="btn ecb-x-public-calendar-navigation-button"
          (click)="goParticipantCalendarPrevious(participantCalendar)"><i class="bi bi-chevron-left"></i></button>
        <button type="button" class="btn ecb-x-public-calendar-navigation-button"
          (click)="goParticipantCalendarNext(participantCalendar)"><i class="bi bi-chevron-right"></i></button>
        <div class="ecb-x-public-calendar-view-buttons">
          <button type="button" class="btn" [class.active]="participantActiveCalendarView === 'dayGridMonth'"
            (click)="changeParticipantCalendarView(participantCalendar, 'dayGridMonth')">Month</button>
          <button type="button" class="btn" [class.active]="participantActiveCalendarView === 'dayGridWeek'"
            (click)="changeParticipantCalendarView(participantCalendar, 'dayGridWeek')">Week</button>
          <button type="button" class="btn" [class.active]="participantActiveCalendarView === 'dayGridDay'"
            (click)="changeParticipantCalendarView(participantCalendar, 'dayGridDay')">Day</button>
        </div>
        <button type="button" class="btn ecb-x-public-calendar-filter-toggle-button"
          (click)="participantIsFilterPanelVisible = !participantIsFilterPanelVisible"><i
            class="bi bi-funnel"></i></button>
        <button type="button" class="btn ecb-x-public-calendar-close-button" (click)="closeParticipantCalendar()"><i
            class="bi bi-x-lg"></i></button>
      </div>
    </div>

    <div class="ecb-x-public-calendar-scroll-content">
      <div class="row g-4">
        <div class="col-12 col-xl-3" *ngIf="participantIsFilterPanelVisible">
          <aside class="ecb-x-public-calendar-filter-panel">
            <div class="ecb-x-public-calendar-filter-header">
              <h4>Filters</h4>
              <button type="button" class="btn" (click)="clearParticipantCalendarFilters()">Clear All</button>
            </div>
            <div class="ecb-x-public-calendar-filter-section">
              <label class="ecb-x-public-calendar-filter-label">Course Type</label>
              <div class="ecb-x-public-calendar-filter-course-item" *ngFor="let filter of participantCourseTypeFilters"
                (click)="toggleParticipantCourseFilter(filter)">
                <div class="ecb-x-public-calendar-filter-checkbox" [class.selected]="filter.selected"><i
                    class="bi bi-check" *ngIf="filter.selected"></i></div>
                <span class="ecb-x-public-calendar-filter-color"
                  [style.backgroundColor]="filter.backgroundColor"></span>
                <span class="ecb-x-public-calendar-filter-name">{{ filter.name }}</span>
                <span class="ecb-x-public-calendar-filter-count">{{ filter.count }}</span>
              </div>
            </div>
            <div class="ecb-x-public-calendar-filter-section">
              <label for="participantCalendarLocation" class="ecb-x-public-calendar-filter-label">Location</label>
              <select id="participantCalendarLocation" class="form-select ecb-x-public-calendar-location-select"
                [(ngModel)]="participantSelectedLocation" name="participantCalendarLocation">
                <option value="">All Locations</option>
                <option *ngFor="let location of participantAvailableLocations" [value]="location">{{ location }}
                </option>
              </select>
            </div>
            <button type="button" class="btn ecb-x-public-calendar-apply-button"
              (click)="applyParticipantCalendarFilters()">Apply Filters</button>
          </aside>
        </div>

        <div [ngClass]="participantIsFilterPanelVisible ? 'col-12 col-xl-9' : 'col-12'">
          <div class="ecb-x-public-calendar-wrapper">

            <div class="ecb-x-public-calendar-month-title">
              <h2>{{ participantCalendarTitle }}</h2>
            </div>
            <div class="ecb-x-participant-calendar-loading" *ngIf="isParticipantCalendarLoading">
              <div class="spinner-border" role="status"></div>
            </div>
            <full-calendar #participantCalendar [options]="participantCalendarOptions"></full-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End PARTICIPANT CALENDAR MODAL -->
 
<!--Start  PARTICIPANT COURSE DETAILS / UOC / VOC SELECTION MODAL -->
<div class="ecb-x-participant-calendar-backdrop" *ngIf="showParticipantCourseSelectionModal"
  (click)="closeParticipantCourseSelection()">
  <div class="ecb-x-participant-course-modal ecb-x-corporate-course-booking-modal" (click)="$event.stopPropagation()">
    <div class="ecb-x-corporate-course-booking-header">
      <div>
        <h2>{{ selectedParticipantOccurrence?.courseCode }} - {{ selectedParticipantOccurrence?.courseName }}</h2>
        <span class="ecb-x-corporate-course-booking-type-badge">Training Course</span>
      </div>
      <div class="ecb-x-corporate-course-booking-header-actions">
        <button type="button" class="btn ecb-x-corporate-course-back-header-button"
          (click)="backToParticipantCalendar()"><i class="bi bi-arrow-left"></i> Back</button>

        <button type="button" class="btn ecb-x-corporate-course-booking-main-button"
          (click)="applyParticipantCalendarSelection()"><span>Continue</span><i class="bi bi-arrow-right"></i></button>
        <button type="button" class="ecb-x-corporate-course-details-close-button"
          (click)="closeParticipantCourseSelection()"><i class="bi bi-x-lg"></i></button>
      </div>
    </div>

    <div class="ecb-x-corporate-course-booking-scroll-content">
      <div class="ecb-x-corporate-course-booking-description" *ngIf="selectedParticipantOccurrence?.description"  [innerHTML]="selectedCourseDetails?.description | normalizeRteSpacing | safeHtml"> </div>

      <div class="ecb-x-corporate-course-booking-information-strip">
        <div class="ecb-x-corporate-course-booking-strip-item">
          <div class="ecb-x-corporate-course-booking-strip-icon"><i class="bi bi-calendar-check"></i></div>
          <div><small>ASSESSMENT</small><strong>{{ selectedParticipantOccurrence?.assessment || 'Practical and Knowledge    Assessment' }}</strong></div>
        </div>
        <div class="ecb-x-corporate-course-booking-strip-divider"></div>
        <div class="ecb-x-corporate-course-booking-strip-item">
          <div class="ecb-x-corporate-course-booking-strip-icon"><i class="bi bi-clock"></i></div>
          <div><small>COURSE DATES</small><strong>{{ selectedParticipantOccurrence?.startDate | date:'dd MMM yyyy' }} -
              {{ selectedParticipantOccurrence?.endDate | date:'dd MMM yyyy' }}</strong></div>
        </div>
      </div>

      <div class="alert alert-danger ecb-x-calendar-selection-error" *ngIf="participantCalendarErrorMessage">{{
        participantCalendarErrorMessage }}</div>

      <div class="row g-4 ecb-x-corporate-course-booking-content">
        <div class="col-12 col-lg-6">
          <div class="ecb-x-corporate-course-booking-detail-row"><span>Registrations Close</span><strong><ng-container
                *ngIf="selectedParticipantOccurrence?.registrationEndDate; else noRegistrationClose">{{
                selectedParticipantOccurrence?.registrationEndDate | date:'dd MMM yyyy' }}</ng-container><ng-template
                #noRegistrationClose>Contact ECB</ng-template></strong></div>
          <div class="ecb-x-corporate-course-booking-detail-row"><span>Course Dates</span><strong>{{
              selectedParticipantOccurrence?.startDate | date:'dd MMM yyyy' }} to {{
              selectedParticipantOccurrence?.endDate | date:'dd MMM yyyy' }}</strong></div>
          <div class="ecb-x-corporate-course-booking-detail-row"><span>Vacancies</span><strong
              class="ecb-x-corporate-course-booking-vacancies">{{ selectedParticipantOccurrence?.availableSeats }} Seats
              Available</strong></div>
          <div class="ecb-x-corporate-course-booking-detail-row"><span>Location</span><strong
              class="ecb-x-corporate-course-booking-location"><i class="bi bi-geo-alt"></i> {{
              selectedParticipantOccurrence?.location || 'Contact ECB' }}</strong></div>

          <div class="ecb-x-corporate-course-booking-selection-box">
            <h5><i class="bi bi-clipboard2-check"></i> Your Selection</h5>
            <div class="ecb-x-corporate-course-booking-selection-row"><span>Primary Course</span><strong>{{
                selectedParticipantOccurrence?.courseCode }} - {{ selectedParticipantOccurrence?.courseName }}</strong>
            </div>
            <div class="ecb-x-corporate-course-booking-selection-row"
              *ngIf="participantSelectedAdditionalUOCs.length > 0"><span>UOC Courses ({{
                participantSelectedAdditionalUOCs.length }})</span><strong><ng-container
                  *ngFor="let course of participantSelectedAdditionalUOCs; let last = last">{{ course.courseCode }}<span
                    *ngIf="!last">, </span></ng-container></strong></div>
            <div class="ecb-x-corporate-course-booking-selection-row"
              *ngIf="participantSelectedAdditionalVOCs.length > 0"><span>VOC Courses ({{
                participantSelectedAdditionalVOCs.length }})</span><strong><ng-container
                  *ngFor="let voc of participantSelectedAdditionalVOCs; let last = last">{{ voc.vocCode }}<span
                    *ngIf="!last">, </span></ng-container></strong></div>
            <div class="ecb-x-corporate-course-booking-selection-total">
              <div><i class="bi bi-collection"></i><span>Total Courses</span><strong>{{ participantTotalSelectedCourses
                  }}</strong></div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="ecb-x-corporate-course-booking-add-box">
            <h4>Add UOC Course(s)</h4>
            <p>
              Select one or more UOC courses to book along with this course.
            </p>
            <select class="form-select" [(ngModel)]="participantSelectedUOCId" name="participantSelectedUOCId"
              (change)="addParticipantSelectedUOC()">
              <option [ngValue]="null">Select UOC Course</option>
              <option *ngFor="let course of participantAvailableUOCCourses" [ngValue]="course.id">{{ course.courseCode
                }} - {{ course.courseTitle }}</option>
            </select>
            <!-- Show ALL selected UOCs here, including the primary course clicked in the calendar. -->
            <div class="ecb-x-corporate-course-booking-added-item" *ngFor="let course of participantSelectedUOCs">
              <div>
                <i class="bi bi-check-square-fill"></i>
                <span>
                  <strong>{{ course.courseCode }}</strong> - {{ course.courseTitle }}
                  <small *ngIf="isParticipantPrimaryUOC(course.id)"> (Primary)</small>
                </span>
              </div>

              <!-- The primary calendar course is mandatory, so only additional UOCs can be removed. -->
              <button type="button" *ngIf="!isParticipantPrimaryUOC(course.id)"
                (click)="removeParticipantSelectedUOC(course.id)">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>

          <div class="ecb-x-corporate-course-booking-add-box">
            <h4>Add VOC Course(s) <small>(Optional)</small></h4>
            <p>
              Select one or more VOC courses to book along with this course.
            </p>
            <select class="form-select" [(ngModel)]="participantSelectedVOCId" name="participantSelectedVOCId"
              (change)="addParticipantSelectedVOC()">
              <option [ngValue]="null">Select VOC Course(s)</option>
              <option *ngFor="let voc of participantAvailableVOCCourses" [ngValue]="voc.id">{{ voc.vocCode }} - {{
                voc.vocName }}</option>
            </select>
            <div class="ecb-x-corporate-course-booking-added-item"
              *ngFor="let voc of participantSelectedAdditionalVOCs">
              <div><i class="bi bi-check-square-fill"></i><span><strong>{{ voc.vocCode }}</strong> - {{ voc.vocName
                  }}</span></div>
              <button type="button" (click)="removeParticipantSelectedVOC(voc.id)"><i class="bi bi-x"></i></button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!--End  PARTICIPANT COURSE DETAILS / UOC / VOC SELECTION MODAL -->

<!--Start confirmation popup-->
<p-dialog [(visible)]="showEnquirySuccessPopup" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [style]="{ width: '460px' }">

  <div class="text-center p-3">

    <i class="bi bi-check-circle-fill" style="
        font-size: 52px;
        color: #e35d1a;
      ">
    </i>

    <h3 style="
        margin-top: 18px;
        color: #56302b;
      ">
      Thank you for your enquiry!
    </h3>

    <p style="
        margin-top: 12px;
        color: #555;
        line-height: 1.6;
      ">

        Your course has been sent,

      <br><br>

      returned to our homepage.

    </p>

    <button type="button" class="btn ecb-x-corporate-save-button mt-3" (click)="closeEnquirySuccessPopup()">

      OK

    </button>

  </div>

</p-dialog>
<!--End confirmation popup-->

